module.exports = __webpack_public_path__ + "static/media/email.fed54fe4.png";